import React, { Fragment } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import plus from '../../assets/icons/submit_bill/plus.svg';

const UploadBoxWithIcon = React.memo((props) => {
	const classes = useStyles();
	return (
		<Fragment>
			<input
				color="primary"
				accept="image/*,.pdf"
				type="file"
				disabled={props.disabled}
				onChange={props.handleClick}
				id="icon-button-file"
				style={{ display: 'none' }}
				multiple
			/>
			<label htmlFor="icon-button-file">
				<Grid
					className={classes.newContainer}
					container
					direction="column"
					justify="center"
					alignItems="center"
				>
					<Grid className={classes.iconContainer}>
						<img alt="select" className={classes.plusIcon} src={plus} />
					</Grid>
					<Grid className={classes.contentContainer}>
						<Typography variant="h6" style={{ marginBottom: '10px' }} className={classes.mainTitle}>
							{props.mainTitle}
						</Typography>
						<Typography variant="subtitle1" className={classes.secondaryTitle}>
							{props.secondaryTitle}
						</Typography>
						{/* <Typography variant="subtitle1" className={classes.secondaryTitle}>
							{props.note}
						</Typography> */}
					</Grid>
				</Grid>
			</label>
		</Fragment>
	);
});

export default UploadBoxWithIcon;
